import * as React from "react";
import type { SVGProps } from "react";
const SvgCheckFilled = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <circle cx={12} cy={12} r={10} fill="#fff" />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m3.78-12.375.626-.781-1.562-1.25-.625.781-3.302 4.128-1.21-1.21L9 11.586 7.586 13l.707.707 2 2a1 1 0 0 0 1.488-.082z"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgCheckFilled;
